module.exports = __webpack_public_path__ + "static/media/gift.6653e539.webp";